import { ItineraryCheckupErrors } from './../itinerary-checker.service';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-itinerary-checkup',
  templateUrl: './itinerary-checkup.component.html',
  styleUrls: ['./itinerary-checkup.component.css']
})
export class ItineraryCheckupComponent implements OnInit {

  @Output()
  errorClick = new EventEmitter<void>();

  valid = true;

  @Input()
  errors: ItineraryCheckupErrors;

  constructor() { }

  ngOnInit() {
    for (const key of Object.keys(this.errors)) {
      this.valid = this.valid && this.errors[key].length === 0;
    }
  }

  getErrorKeysWithErrors(errors: ItineraryCheckupErrors) {
    return Object.keys(this.errors).filter((errorKey) => errors[errorKey].length > 0);
  }

}
